import { useQuery } from "convex/react";

import { api } from "@convex/_generated/api";

/**
 * Subscribes to the user's full bead workspace (beads + dep edges + label
 * edges). Consumed by TasksTab, GraphTab, and BeadDetailDrawer — Convex
 * dedupes the underlying subscription.
 */
export function useBeads() {
  const result = useQuery(api.beads.listForCurrentUser, {});
  return {
    beads: result?.beads ?? [],
    dependencies: result?.dependencies ?? [],
    labels: result?.labels ?? [],
    isLoading: result === undefined,
  };
}
